import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getrefid, actualizarEstado, getUsuariomuetre, postDatlotes, updateDatlote, deleteDatlote, getorigenes, postorigenes, getidorigen } from "../../../redux/actions";
import { FaArrowLeft } from "react-icons/fa";
import styles from "./DetallesInbound.module.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import HashLoader from "react-spinners/HashLoader";
import { FaFileExcel, FaCheckCircle, FaPauseCircle, FaTimesCircle } from "react-icons/fa";
import Swal from 'sweetalert2';
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaEdit, FaTrash, FaPlusCircle } from "react-icons/fa";



const DetallesInbound = () => {
    const location = useLocation();
    const referencia = location.state?.referencia || "Desconocida";
    const refidData = useSelector((state) => state.refid);
    const listPreparadores = useSelector((state) => state.usuariomuetre?.usuarios || []);
    // console.log("REFID", refidData)
    const registros = (location.state?.registros || refidData?.Registros || []).map(reg => ({
        ...reg,
        lote: reg.lote_num,
        origen: reg.origen_material_nombre,
    }));
    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mostrarInfo, setMostrarInfo] = useState(false);
    const [muestreado, setMuestreado] = useState("");
    const [registrado, setRegistrado] = useState("");
    const [rotation, setRotation] = useState(0);
    const [nuevaFoto, setNuevaFoto] = useState(null);
    const [showAgregarLoteModal, setShowAgregarLoteModal] = useState(false);
    const [materiales, setMateriales] = useState([]);
    const [nuevoLoteData, setNuevoLoteData] = useState({
        placa: "",
        pesoneto: "",
        temp1: "",
        temp2: "",
        temp3: "",
        temp4: "",
        polucion: "Normal",
        observaciones: "",
        idmaterial: "",
        nom_material: "",
        Idusuariom: "",
        Idusuarior: "",
        planapptual: "",
        esNuevoOrigen: false,
    });


    const registrosFiltrados = registros.filter(
        (reg) => reg.Idestado !== 1 && reg.lote && reg.origen && reg.descripcion_estado !== "Finalizado"
    );

    //console.log("FILTRADOS::", registrosFiltrados)

    const [showAgregarModal, setShowAgregarModal] = useState(false);
    const [collapsedOrigins, setCollapsedOrigins] = useState({});

    // Inicializar orígenes como colapsados por defecto si no están en el estado
    const isOriginCollapsed = (origenName) => {
        return collapsedOrigins[origenName] !== false; // Por defecto true (colapsado)
    };

    const toggleCollapsedOrigin = (origenName) => {
        setCollapsedOrigins(prev => ({
            ...prev,
            [origenName]: !isOriginCollapsed(origenName)
        }));
    };

    const { Idref } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // console.log(refidData)

    const [selectedLote, setSelectedLote] = useState(null);
    const [editRegistro, setEditRegistro] = useState(null); // Para editar un registro
    useEffect(() => {
        if (Idref) {
            setLoading(true); // empieza a cargar
            dispatch(getrefid(Idref)).then(() => {
                setTimeout(() => {
                    setLoading(false); // termina de cargar
                }, 1000);
            });
        }
    }, [dispatch, Idref]);

    useEffect(() => {
        dispatch(getUsuariomuetre());
        cargarMateriales();
    }, [dispatch]);

    const cargarMateriales = async () => {
        try {
            const data = await dispatch(getorigenes());
            // Filtrar por Idref como en el movil
            const filtrados = data.filter(m => m.Idref === Number(Idref));
            setMateriales(filtrados);
        } catch (error) {
            console.error("Error al cargar materiales:", error);
        }
    };

    const handleGuardarNuevoOrigen = async () => {
        if (!nuevoLoteData.nom_material.trim()) {
            Swal.fire("Aviso", "Ingrese el nombre del nuevo origen", "warning");
            return;
        }

        try {
            const response = await dispatch(postorigenes({
                nombre: nuevoLoteData.nom_material.toUpperCase(),
                Idref: Number(Idref)
            }));

            if (response) {
                Swal.fire("¡Éxito!", "Nuevo origen agregado correctamente", "success");
                setNuevoLoteData(prev => ({ ...prev, esNuevoOrigen: false, nom_material: "" }));
                cargarMateriales(); // Recargar lista
            }
        } catch (error) {
            Swal.fire("Error", error.response?.data?.error || "No se pudo agregar el origen", "error");
        }
    };

    // 🔹 Agrupar registros por origen y luego por lote
    const origenes = registrosFiltrados.reduce((acc, reg) => {
        const origen = reg.origen_material_nombre || "Desconocido";
        const lote = reg.lote_num != null ? reg.lote_num.toString() : "0";

        if (!acc[origen]) acc[origen] = {};
        if (!acc[origen][lote]) acc[origen][lote] = [];
        acc[origen][lote].push(reg);
        return acc;
    }, {});

    const lotes = registros.reduce((acc, reg) => {
        const lote = reg.lote_num != null ? reg.lote_num.toString() : "0";
        if (!acc[lote]) acc[lote] = [];
        acc[lote].push(reg);
        return acc;
    }, {});


    // 🔹 Agrupar registros por origen y luego por lote
    const origenesProcesados = Object.entries(origenes).map(([nombreOrigen, lotes]) => {
        const lotesArray = Object.entries(lotes).map(([lote, registrosLote]) => {
            registrosLote.sort((a, b) => new Date(b.fechacompleta) - new Date(a.fechacompleta));
            const ultimoRegistro = registrosLote[0];
            const acumuladoLote = registrosLote.reduce((sum, reg) => sum + Number(reg.pesoneto || 0), 0);

            return {
                lote,
                registros: registrosLote,
                fechaUltima: ultimoRegistro.fechacompleta,
                estado: ultimoRegistro.Idestado,
                descripcion_estado: ultimoRegistro.descripcion_estado,
                cantidadRegistros: registrosLote.length,
                acumuladoLote,
            };
        });

        return {
            nombreOrigen,
            lotes: lotesArray,
        };
    });

    // 🔹 Procesar lotes
    const lotesProcesados = Object.keys(lotes)
        .map((lote) => {
            const registrosLote = lotes[lote];

            registrosLote.sort((a, b) => new Date(b.fechacompleta) - new Date(a.fechacompleta));
            const ultimoRegistro = registrosLote[0];
            const acumuladoLote = registrosLote.reduce((sum, reg) => sum + Number(reg.pesoneto || 0), 0);

            return {
                lote,
                fechaUltima: ultimoRegistro.fechacompleta,
                estado: ultimoRegistro.Idestado,
                descripcion_estado: ultimoRegistro.descripcion_estado,
                registros: registrosLote,
                cantidadRegistros: registrosLote.length,
                acumuladoLote,
                incre_veh: registrosLote.incre_veh
            };
        })
        .filter(({ registros, estado }) => !(registros.length === 1 && estado === 1));

    // 🔹 Abrir modal con detalles del lote seleccionado
    const handleOpenModal = (lote) => {
        setSelectedLote(lote);
    };

    // 🔹 Cerrar modal
    const handleCloseModal = () => {
        setSelectedLote(null);
        setEditRegistro(null); // Resetear el registro editado cuando se cierra el modal
    };

    const handleCellClick = (registro) => {
        setEditRegistro({
            ...registro,
            fecha_original: registro.fechacompleta.split("T")[0],
            hora_original: registro.fechacompleta.split("T")[1].substring(0, 5),
            fecha_edit: null,
            hora_edit: null,
        });
    };


    const handleCloseEditModal = () => {
        setEditRegistro(null); // Cerrar el modal de edición
    };

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        if (!editRegistro) return;

        try {
            // ⬅ AHORA usamos los valores editados del usuario
            const fecha = editRegistro.fecha_edit || editRegistro.fecha_original;
            let fechacompletaFinal;

            // si NO se editó nada
            if (!editRegistro.fecha_edit && !editRegistro.hora_edit) {
                fechacompletaFinal = editRegistro.fechacompleta;
            } else {
                // si el usuario sí editó algo
                const fecha = editRegistro.fecha_edit || editRegistro.fecha_original;
                const hora = editRegistro.hora_edit || editRegistro.hora_original;
                fechacompletaFinal = unirFechaHora(fecha, hora);
            }

            const formData = new FormData();

            formData.append("fechacompleta", fechacompletaFinal);

            formData.append("Idref", Number(Idref));
            formData.append("id", editRegistro.id);

            formData.append("placa", editRegistro.placa);
            formData.append("pesoneto", editRegistro.pesoneto);

            formData.append("temp1", editRegistro.temp1 || "");
            formData.append("temp2", editRegistro.temp2 || "");
            formData.append("temp3", editRegistro.temp3 || "");
            formData.append("temp4", editRegistro.temp4 || "");
            formData.append("observaciones", editRegistro.observaciones || "");

            formData.append("Idusuariom", editRegistro.Idusuariom || "");
            formData.append("Idusuarior", editRegistro.Idusuarior || "");

            formData.append("polucion", editRegistro.polucion || "");
            formData.append("paral", editRegistro.paral ? 1 : 0);

            if (nuevaFoto) {
                formData.append("fototick", nuevaFoto);
            }

            // PARA VER TODO LO QUE SE ENVÍA
            console.log("SEVA::");
            for (let pair of formData.entries()) {
                console.log(pair[0] + ": " + pair[1]);
            }

            const response = await dispatch(updateDatlote(formData));

            if (response?.success || response?.message) {
                Swal.fire({
                    icon: "success",
                    title: "Registro actualizado correctamente",
                    timer: 1500,
                    showConfirmButton: false
                });

                setEditRegistro(null);
                dispatch(getrefid(Idref));
            } else {
                throw new Error("No se pudo actualizar el registro");
            }

        } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || "Error al actualizar el registro";
            Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMsg,
            });
        }
    };



    const handleDelete = async () => {
        const confirmDelete = window.confirm("¿Está seguro que desea eliminar este dato?");

        if (!confirmDelete) return;

        try {
            await dispatch(deleteDatlote(editRegistro.id));
            alert("Registro eliminado correctamente");
            handleCloseEditModal();
            dispatch(getrefid(Idref));
        } catch (error) {
            console.error("Error eliminando el registro:", error);
            alert("No se pudo eliminar el registro");
        }
    };


    const acomuladoTotal = registros.reduce((sum, reg) => sum + Number(reg.pesoneto || 0), 0);

    // Obtener el registro con la fecha más reciente de todos los lotes
    const ultimoRegistroGeneral = registros.reduce((ultimo, reg) => {
        return !ultimo || new Date(reg.fechacompleta) > new Date(ultimo.fechacompleta) ? reg : ultimo;
    }, null);

    const estadoGeneral = ultimoRegistroGeneral ? ultimoRegistroGeneral.descripcion_estado : "Desconocido";
    const mostrarBotonAgregar = estadoGeneral === "Creado" || estadoGeneral === "Lote cerrado";
    // Obtener el lote con el número más alto
    const loteMayor = Math.max(
        ...origenesProcesados.flatMap(origen => origen.lotes.map(l => Number(l.lote)))
    );

    const handleAgregarNuevoLote = async (e) => {
        e.preventDefault();

        if (!nuevoLoteData.idmaterial) {
            Swal.fire("Error", "Por favor seleccione un origen", "error");
            return;
        }

        const userToken = sessionStorage.getItem("token");

        // VALIDACIÓN DE ESTADO (como en el movil)
        try {
            const estadoData = await dispatch(getidorigen({
                Idref: Number(Idref),
                Idorigen: Number(nuevoLoteData.idmaterial)
            }));

            if (estadoData && estadoData.Idestado === 2) {
                Swal.fire("Registro bloqueado", "No se puede crear el registro porque el lote anterior aún está en curso.", "warning");
                return;
            }
        } catch (error) {
            console.warn("Validación de estado omitida por error de red.");
        }

        const formData = new FormData();

        // 1. Priorizar el plan seleccionado manualmente, si no, usar el primero disponible
        const activePlanId = nuevoLoteData.planapptual || refidData.PlanesMuestreo?.[0]?.id || refidData.Planmuestreo?.id || "";

        if (!activePlanId) {
            Swal.fire("Error", "No hay un plan de muestreo activo para esta referencia", "error");
            return;
        }

        // 2. Determinar el nombre del material desde la lista cargada
        const idMaterialFinal = nuevoLoteData.idmaterial;
        const materialSeleccionado = materiales.find(m => m.id == idMaterialFinal);
        const nomMaterialFinal = materialSeleccionado ? materialSeleccionado.nombre : "";

        if (!idMaterialFinal) {
            Swal.fire("Error", "Debe seleccionar un origen válido de la lista", "error");
            return;
        }

        // 3. Preparar FormData
        const ahora = new Date();
        const fechaActualStr = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')}`;
        const horaActualStr = `${String(ahora.getHours()).padStart(2, '0')}:${String(ahora.getMinutes()).padStart(2, '0')}`;
        const fechaUnida = unirFechaHora(fechaActualStr, horaActualStr);

        formData.append("fechacompleta", fechaUnida);
        formData.append("placa", nuevoLoteData.placa.trim());
        formData.append("pesoneto", nuevoLoteData.pesoneto);
        formData.append("temp1", nuevoLoteData.temp1);
        formData.append("temp2", nuevoLoteData.temp2);
        formData.append("temp3", nuevoLoteData.temp3);
        formData.append("temp4", nuevoLoteData.temp4);
        formData.append("polucion", nuevoLoteData.polucion);
        formData.append("observaciones", nuevoLoteData.observaciones);
        formData.append("Idestado", 2); // En curso
        // formData.append("fechaflag", 1);
        formData.append("Idref", Number(Idref));
        formData.append("idmaterial", idMaterialFinal);
        formData.append("nom_material", nomMaterialFinal);
        formData.append("planapptual", activePlanId);
        formData.append("Idusuariom", nuevoLoteData.Idusuariom);
        formData.append("Idusuarior", nuevoLoteData.Idusuarior);
        formData.append("newlot", 2);
        formData.append("paral", location.state?.paralelo || 0);

        // Foto (si existe algun input de foto que queramos agregar aqui)
        if (nuevaFoto) {
            formData.append("fototick", nuevaFoto);
        }

        try {
            const response = await dispatch(postDatlotes(formData));

            if (response?.message === "Registro actualizado correctamente") {
                Swal.fire({
                    icon: "success",
                    title: "Nuevo lote creado correctamente",
                    timer: 1500,
                    showConfirmButton: false
                });

                setShowAgregarLoteModal(false);
                setNuevoLoteData({
                    placa: "", pesoneto: "", temp1: "", temp2: "", temp3: "", temp4: "",
                    polucion: "Normal", observaciones: "", idmaterial: "", nom_material: "",
                    Idusuariom: "", Idusuarior: "", planapptual: "", esNuevoOrigen: false
                });
                dispatch(getrefid(Idref));
            } else {
                throw new Error(response?.error || "Error al crear el lote");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || "No se pudo crear el nuevo lote";
            Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMsg,
            });
        }
    };

    function unirFechaHora(fecha, hora) {
        // Unimos la fecha y hora tal cual las selecciona el usuario
        const [year, month, day] = fecha.split("-");
        const [hh, mm] = hora.split(":");

        const horas = String(hh).padStart(2, "0");
        const minutos = String(mm).padStart(2, "0");
        const segundos = "00";
        const milis = "000";

        // Forzar siempre zona horaria -05
        const offset = "-05";

        return `${year}-${month}-${day} ${horas}:${minutos}:${segundos}.${milis}${offset}`;
    }

    // 🔄 Cuando el backend se recarga, actualiza el modal automáticamente
    useEffect(() => {
        if (!selectedLote) return;

        const nuevosRegistros = refidData?.Registros?.filter(
            r => r.lote_num == selectedLote.lote && r.Idorigen == selectedLote.registros[0].Idorigen
        );

        if (nuevosRegistros?.length > 0) {
            setSelectedLote(prev => ({
                ...prev,
                registros: nuevosRegistros,
                cantidadRegistros: nuevosRegistros.length,
                acumuladoLote: nuevosRegistros.reduce((sum, r) => sum + Number(r.pesoneto), 0),
                fechaUltima: nuevosRegistros[0].fechacompleta
            }));
        }
    }, [refidData]); // 👈 se ejecuta cuando getrefid termina

    const handleAgregarDato = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Campos del formulario:
        const fechaUnida = unirFechaHora(e.target.fecha.value, e.target.hora.value);
        formData.append("fechacompleta", fechaUnida);
        formData.append("placa", e.target.placa.value.trim());
        formData.append("pesoneto", e.target.pesoneto.value);
        formData.append("temp1", e.target.temp1.value);
        formData.append("temp2", e.target.temp2.value);
        formData.append("temp3", e.target.temp3.value);
        formData.append("temp4", e.target.temp4.value);
        formData.append("polucion", e.target.polucion.value);
        formData.append("observaciones", e.target.observaciones.value);
        formData.append("Idestado", 2);
        formData.append("fechaflag", 1);


        // Usuarios (IDs o nombres)
        formData.append("Idusuariom", muestreado);
        formData.append("Idusuarior", registrado);

        // Foto
        if (e.target.foto.files.length > 0) {
            const file = e.target.foto.files[0];
            formData.append("fototick", file);
        }

        // Datos obligatorios del lote
        formData.append("Idref", Number(Idref));
        formData.append("lote", selectedLote.lote);
        formData.append("idmaterial", selectedLote.registros[0].Idorigen);
        formData.append("planapptual", selectedLote.registros[0]?.Idplan || "");

        try {
            const response = await dispatch(postDatlotes(formData));

            if (response?.message === "Registro actualizado correctamente") {
                Swal.fire({
                    icon: "success",
                    title: "Dato agregado correctamente",
                    timer: 1500,
                    showConfirmButton: false
                });

                setShowAgregarModal(false);

                // Recargar todos los datos del inbound
                dispatch(getrefid(Idref));


            } else {
                throw new Error("Error al guardar los datos");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || "No se pudieron guardar los datos";
            Swal.fire({
                icon: "error",
                title: "Error",
                text: errorMsg,
            });
        }
    };

    const exportarAExcel = () => {
        const registrosOrdenados = selectedLote.registros
            .slice()
            .sort((a, b) => new Date(a.fechacompleta) - new Date(b.fechacompleta));

        let acumulado = 0;

        const data = registrosOrdenados.map((reg) => {
            acumulado += Number(reg.pesoneto || 0);

            return {
                Fecha: formatearFechaSimple(reg.fechacompleta),
                Hora: new Date(reg.fechacompleta).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", hour12: false }),
                Placa: reg.placa || "N/A",
                "Peso Neto (t)": Number(reg.pesoneto).toFixed(2).replace(".", ","),
                "Acumulado (t)": Number(acumulado).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ","),
                Temp1: reg.temp1,
                Temp2: reg.temp2,
                Temp3: reg.temp3,
                Temp4: reg.temp4,
                Máx: reg.MaxTemp,
                Mín: reg.MinTemp,
                Polución: reg.polucion,
                Observaciones: reg.observaciones,
                Muestreado: reg.nombre_usuario_m,
                Registrado: reg.nombre_usuario_r,
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Registros");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, `Lote_${selectedLote.lote}_Referencia_${referencia}.xlsx`);
    };

    if (loading) {
        return (
            <div className={styles.loaderContainer}>
                <HashLoader color="#3559d1" size={60} />
                <p>Cargando datos espere...</p>
            </div>
        );
    }

    const formatearFechaSimple = (fechaStr) => {
        if (!fechaStr) return "N/A";
        const fecha = new Date(fechaStr);
        if (isNaN(fecha.getTime())) return "N/A";
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        return `${anio}-${mes}-${dia}`;
    };

    const formatearFechaHora = (fechaStr) => {
        if (!fechaStr) return "N/A";
        const fecha = new Date(fechaStr);
        if (isNaN(fecha.getTime())) return "N/A";
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        const hora = String(fecha.getHours()).padStart(2, '0');
        const minuto = String(fecha.getMinutes()).padStart(2, '0');
        return `${anio}-${mes}-${dia} ${hora}:${minuto}`;
    };

    // 👉 Calcular temperatura máxima y mínima del lote completo
    const todasTemperaturas = selectedLote?.registros
        ?.flatMap(reg => [reg.temp1, reg.temp2, reg.temp3, reg.temp4])
        .map(t => Number(t))
        .filter(t => !isNaN(t)) || [];

    const tempMaxLote = todasTemperaturas.length ? Math.max(...todasTemperaturas) : "N/A";
    const tempMinLote = todasTemperaturas.length ? Math.min(...todasTemperaturas) : "N/A";

    // 🔹 Obtener lote mayor por cada origen
    const lotesMaxPorOrigen = origenesProcesados.reduce((acc, origen) => {
        const maxLote = Math.max(...origen.lotes.map(l => Number(l.lote)));
        acc[origen.nombreOrigen] = maxLote;
        return acc;
    }, {});

    // 🔹 Validar si el lote seleccionado es el mayor de su origen
    const origenActual = selectedLote?.registros[0].origen_material_nombre;
    const esLoteMayorDeSuOrigen = selectedLote
        ? Number(selectedLote.lote) === lotesMaxPorOrigen[origenActual]
        : false;


    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate("/inbound")}>
                <FaArrowLeft className={styles.icon} /> Volver
            </button>


            <h2>Detalles de Inbound <span style={{ color: '#6366f1' }}>- Referencia {referencia}</span></h2>
            <div className={styles.infoContainer}>
                <div className={styles.detailsCard}>
                    <div
                        className={styles.detailsHeader}
                        onClick={() => setMostrarInfo(!mostrarInfo)}
                    >
                        <div className={styles.iconToggle}>
                            {mostrarInfo ? '−' : '+'}
                        </div>
                        <h3>{mostrarInfo ? "Ocultar Detalles" : "Mostrar Detalles"}</h3>
                    </div>

                    {mostrarInfo && (
                        <div className={styles.infoGrid}>
                            <div><strong>Cliente:</strong> {refidData.cliente}</div>
                            <div><strong>Ubicación:</strong> {refidData.ubicacion}</div>
                            <div><strong>Lugar:</strong> {refidData.lugar}</div>
                            <div><strong>Material:</strong> {refidData.material}</div>

                            {/* <div>
                                <strong>Tonelaje total:</strong>{" "}
                                {Number(refidData.tonelaje_total)
                                    .toLocaleString("es-ES", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                    .replace(/\./g, " ")}{" "}
                                t
                            </div> */}

                            {/* <div><strong>Tamaño Material:</strong> {refidData.tamano_mate}</div> */}
                            {/* <div><strong>Promedio bolsas por lote:</strong> {Math.round(refidData.bolsa)}</div> */}
                            <div>
                                <strong>Acumulado Total:</strong>{" "}
                                {Number(acomuladoTotal)
                                    .toLocaleString("es-ES", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                        useGrouping: true   // ✅ fuerza separación de miles
                                    })
                                    .replace(/\./g, " ")     // ✅ miles → espacio
                                }{" "}
                                t
                            </div>
                            <div><strong>Estado General:</strong> {estadoGeneral}</div>
                        </div>
                    )}

                </div>
            </div>

            <div className={styles.actionsRow}>
                <div
                    className={styles.customActionCard}
                    onClick={() => setShowAgregarLoteModal(true)}
                    style={{ cursor: "pointer" }}
                >
                    <div className={styles.iconCircle}>
                        <FaCheckCircle />
                    </div>
                    <div className={styles.cardText}>
                        <h4>Agregar Lote</h4>
                        <p>Crear un nuevo lote para la referencia</p>
                    </div>
                </div>

                <div className={styles.customActionCard}>
                    <div className={styles.iconCircle}>
                        <FaTimesCircle />
                    </div>
                    <div className={styles.cardText}>
                        <h4>Finalizar Referencia</h4>
                        <p>Cierra la operación y guarda todo</p>
                    </div>
                </div>
            </div>

            <br /><br />
            {lotesProcesados.length > 0 ? (
                <div className={styles.cardsContainer}>
                    {origenesProcesados.map((origen) => {
                        const isCollapsed = isOriginCollapsed(origen.nombreOrigen);
                        return (
                            <div key={origen.nombreOrigen} className={styles.origenSection}>
                                <div
                                    className={styles.origenHeader}
                                    onClick={() => toggleCollapsedOrigin(origen.nombreOrigen)}
                                >
                                    <div className={styles.iconToggle}>
                                        {isCollapsed ? '+' : '−'}
                                    </div>
                                    <h3>Origen: {origen.nombreOrigen}</h3>
                                </div>

                                {!isCollapsed && (
                                    <div className={styles.cardsContainercard}>
                                        {origen.lotes.map((loteData) => (
                                            <div key={loteData.lote} className={styles.card} onClick={() => handleOpenModal(loteData)}>
                                                <h4>Lote {loteData.lote}</h4>
                                                <p><strong>Última Fecha:</strong> {formatearFechaHora(loteData.fechaUltima)}</p>
                                                <p><strong>Estado:</strong> {loteData.descripcion_estado}</p>
                                                <p>
                                                    <strong>Acumulado:</strong>{" "}
                                                    {Number(loteData.acumuladoLote)
                                                        .toLocaleString("es-ES", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                            useGrouping: true      // ✅ fuerza separación de miles
                                                        })
                                                        .replace(/\./g, " ")      // ✅ miles → espacio
                                                    }{" "}
                                                    t
                                                </p>

                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}

                </div>
            ) : (
                <p>No se han creado lotes para esta referencia.</p>
            )}

            {/* Modal con Tabla */}
            {selectedLote && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal}>
                        <div className={styles.encabezadoModal}>
                            <button className={styles.closeButton} onClick={handleCloseModal}>X</button>
                            <h2>Detalles del Lote {selectedLote.lote} - Referencia {referencia}</h2>
                        </div>
                        <div className={styles.modalContentWrapper}>
                            {(() => {
                                // 1. Determine the active plan for this lot
                                const currentPlan = refidData.PlanesMuestreo?.find(p => p.id === selectedLote.registros[0]?.Idplan) || refidData.Planmuestreo || {};

                                // 2. Perform technical calculations specific to this plan
                                const factorCarga = currentPlan.FactorCargum?.factor || currentPlan.Factorcarga?.factor || 0;
                                // PRIORITIZE plan-specific lot size (tamano_lote from PlanesMuestreo) over global refidData.tamano_lot
                                const tamanoLote = Number(currentPlan.tamano_lote) || Number(refidData.tamano_lot) || 0;

                                // Vehicles (V. Prom) = Total Weight / Load Factor
                                const numVeh = factorCarga > 0 ? (tamanoLote / factorCarga) : 0;

                                // Frequencies
                                const f1 = currentPlan.frecuencia_calidad || 0;
                                const f2 = currentPlan.frecuencia_granulometria || 0;
                                const f3 = currentPlan.frecuencia_1 || 0;


                                const incremento1 = f1 * numVeh;
                                const incremento2 = f2 * numVeh;
                                const incremento3 = f3 * numVeh;
                                // Total Bags = (Sum of Increments) / Increments Per Bag
                                const incrBolsa = currentPlan.incremento_bolsa || 0;

                                const totalBolsas = incrBolsa > 0 ? (incremento1 + incremento2 + incremento3) / incrBolsa : 0;

                                return (
                                    <div className={styles.infoEtiquetas}>
                                        <div><label>Última Fecha</label><p>{formatearFechaHora(selectedLote.fechaUltima)}</p></div>
                                        <div><label>Veh. Prom</label><p>{Math.ceil(numVeh)}</p></div>
                                        <div><label>Tamaño</label><p>{Number(tamanoLote).toLocaleString("es-ES", { minimumFractionDigits: 2 })} t</p></div>
                                        <div><label>Material</label><p>{refidData.material}</p></div>
                                        <div><label>Granulo.</label><p>{Math.ceil(f2)}</p></div>
                                        <div><label>Calidad</label><p>{Math.ceil(f1)}</p></div>
                                        {/* <div><label>Masa Incr.</label><p>{currentPlan.masa_incremento || 0}</p></div> */}
                                        <div><label>Bolsas</label><p>{Math.ceil(totalBolsas)}</p></div>
                                        <div><label>Registrados</label><p>{selectedLote.cantidadRegistros}</p></div>
                                        <div><label>Estado</label><p>{selectedLote.descripcion_estado}</p></div>
                                        <div><label>Acumulado</label><p>{Number(selectedLote.acumuladoLote).toLocaleString("es-ES", { minimumFractionDigits: 2 })} t</p></div>
                                        <div><label>Temp M/m</label><p>{tempMaxLote}° / {tempMinLote}°</p></div>
                                    </div>
                                );
                            })()}

                            <div className={styles.modalActionBar}>
                                <div className={styles.statusGroup}>
                                    {esLoteMayorDeSuOrigen && selectedLote.estado !== 6 && (
                                        <>
                                            <button
                                                className={styles.closeLoteButton}
                                                onClick={async () => {
                                                    const payload = {
                                                        Idref: Number(Idref),
                                                        Idestado: 6,
                                                        Idorigen: selectedLote.registros[0].Idorigen,
                                                    };
                                                    try {
                                                        const result = await dispatch(actualizarEstado(payload));
                                                        if (result?.success) {
                                                            Swal.fire({
                                                                icon: 'success',
                                                                title: 'Lote cerrado con éxito',
                                                                showConfirmButton: false,
                                                                timer: 1500
                                                            });
                                                            setSelectedLote(prev => ({ ...prev, estado: 6, descripcion_estado: "Lote cerrado" }));
                                                            dispatch(getrefid(Idref));
                                                        } else {
                                                            throw new Error("Error al cerrar el lote.");
                                                        }
                                                    } catch (error) {
                                                        Swal.fire({ icon: 'error', title: 'Error al cerrar lote', text: error.message || 'Algo salió mal.' });
                                                    }
                                                }}
                                            >
                                                <FaCheckCircle /> Cerrar Lote
                                            </button>
                                            <button className={styles.pauseButton}><FaPauseCircle /> Pausar</button>
                                            <button className={styles.cancelButton}><FaTimesCircle /> Cancelar</button>
                                        </>
                                    )}
                                    {esLoteMayorDeSuOrigen && selectedLote.estado === 6 && (
                                        <button
                                            className={styles.activateButton}
                                            onClick={async () => {
                                                const payload = {
                                                    Idref: Number(Idref),
                                                    Idestado: 2,
                                                    Idorigen: selectedLote.registros[0].Idorigen,
                                                };
                                                try {
                                                    const result = await dispatch(actualizarEstado(payload));
                                                    if (result?.success) {
                                                        Swal.fire({
                                                            icon: 'success',
                                                            title: 'Lote activado con éxito',
                                                            showConfirmButton: false,
                                                            timer: 1500
                                                        });
                                                        setSelectedLote(prev => ({ ...prev, estado: 2, descripcion_estado: "Activo" }));
                                                        dispatch(getrefid(Idref));
                                                    } else {
                                                        throw new Error("Error al activar el lote.");
                                                    }
                                                } catch (error) {
                                                    Swal.fire({ icon: 'error', title: 'Error al activar lote', text: error.message || 'Algo salió mal.' });
                                                }
                                            }}
                                        >
                                            Activar Lote
                                        </button>
                                    )}
                                </div>
                                <div className={styles.dataGroup}>
                                    <h3 className={styles.modalSubTitle}>Registros del Lote</h3>
                                    <div className={styles.dataActions}>
                                        <button className={styles.exportButton} onClick={exportarAExcel}>
                                            <FaFileExcel /> Exportar
                                        </button>
                                        {selectedLote.descripcion_estado !== "Lote cerrado" && (
                                            <button className={styles.Buttons} onClick={() => setShowAgregarModal(true)}>
                                                + Datos
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.tableContainer}>
                            <table className={styles.tableRegistros}>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Placa</th>
                                        <th>Peso Neto (t)</th>
                                        <th>Acumulado (t)</th>
                                        <th>Temp1</th>
                                        <th>Temp2</th>
                                        <th>Temp3</th>
                                        <th>Temp4</th>
                                        <th>Máx</th>
                                        <th>Mín</th>
                                        <th>Polución</th>
                                        <th>Observaciones</th>
                                        <th>Muestreado</th>
                                        <th>Registrado</th>
                                        <th>Foto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedLote.registros
                                        .slice() // Clona el array para no modificar el original
                                        .sort((a, b) => new Date(a.fechacompleta) - new Date(b.fechacompleta)) // Ordena de más antiguo a más reciente
                                        .reduce((acc, reg, index) => {
                                            const acumulado = acc.acumulado + Number(reg.pesoneto || 0);
                                            acc.acumulado = acumulado; // Acumulado total hasta esta fila
                                            acc.rows.push(
                                                <tr key={index}>
                                                    <td onClick={() => handleCellClick(reg)}>
                                                        {formatearFechaSimple(reg.fechacompleta)}
                                                    </td>
                                                    <td onClick={() => handleCellClick(reg)}>
                                                        {new Date(reg.fechacompleta).toLocaleTimeString("es-ES", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: false
                                                        })}
                                                    </td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.placa || "N/A"}</td>

                                                    {/* Peso neto: solo 2 decimales con coma */}
                                                    <td onClick={() => handleCellClick(reg)}>
                                                        {Number(reg.pesoneto).toFixed(2).replace(".", ",")}
                                                    </td>

                                                    {/* Acumulado: separación de miles con espacio + coma decimal */}
                                                    <td onClick={() => handleCellClick(reg)}>
                                                        {(() => {
                                                            const valor = Number(acumulado).toFixed(2);
                                                            return valor.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
                                                        })()}
                                                    </td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.temp1}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.temp2}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.temp3}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.temp4}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.MaxTemp}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.MinTemp}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.polucion}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.observaciones || "Ninguna"}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.nombre_usuario_m}</td>
                                                    <td onClick={() => handleCellClick(reg)}>{reg.nombre_usuario_r}</td>
                                                    <td>
                                                        {reg.fototick ? (
                                                            <img
                                                                src={`https://reporte.incolabcolombia.com.co/${reg.fototick}`} // Ajusta el puerto y dominio según tu backend
                                                                alt="Foto"
                                                                style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
                                                                onClick={() => setImagenSeleccionada(reg.fototick)}
                                                            />
                                                        ) : (
                                                            "Sin foto"
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                            return acc;
                                        }, { acumulado: 0, rows: [] }).rows}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            )}

            {showAgregarModal && (
                <div className={styles.modalOverlay}>
                    <div className={`${styles.modal} ${styles.modalForm}`}>
                        <div className={styles.encabezadoModal}>
                            <button className={styles.closeButton} onClick={() => setShowAgregarModal(false)}>X</button>
                            <h2>Agregar datos al lote</h2>
                        </div>

                        <form className={styles.formAgregarDato} onSubmit={handleAgregarDato}>
                            <div className={styles.formBody}>
                                <div className={styles.formGrid}>
                                    <div className={styles.formGroup}><label>Fecha</label><input type="date" name="fecha" required /></div>
                                    <div className={styles.formGroup}><label>Hora</label><input type="time" name="hora" required /></div>
                                    <div className={styles.formGroup}><label>Placa</label><input type="text" name="placa" required /></div>
                                    <div className={styles.formGroup}><label>Peso Neto (t)</label><input type="number" step="0.01" name="pesoneto" required /></div>
                                    <div className={styles.formGroup}><label>Temp1</label><input type="number" step="0.01" name="temp1" /></div>
                                    <div className={styles.formGroup}><label>Temp2</label><input type="number" step="0.01" name="temp2" /></div>
                                    <div className={styles.formGroup}><label>Temp3</label><input type="number" step="0.01" name="temp3" /></div>
                                    <div className={styles.formGroup}><label>Temp4</label><input type="number" step="0.01" name="temp4" /></div>
                                    <div className={styles.formGroup}>
                                        <label>Polución</label>
                                        <select name="polucion" defaultValue="Normal" required>
                                            <option value="">Seleccione...</option>
                                            <option value="Normal">Normal</option>
                                            <option value="Media">Media</option>
                                            <option value="Alta">Alta</option>
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Muestreado</label>
                                        <select name="muestreado" value={muestreado} onChange={(e) => setMuestreado(e.target.value)} required>
                                            <option value="">Seleccione...</option>
                                            {listPreparadores.map((prep) => (<option key={prep.id} value={prep.id}>{prep.nombre}</option>))}
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Registrado</label>
                                        <select name="registrado" value={registrado} onChange={(e) => setRegistrado(e.target.value)} required>
                                            <option value="">Seleccione...</option>
                                            {listPreparadores.map((prep) => (<option key={prep.id} value={prep.id}>{prep.nombre}</option>))}
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}><label>Foto</label><input type="file" name="foto" accept="image/*" /></div>
                                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                        <label>Observaciones</label>
                                        <textarea name="observaciones" rows="2" placeholder="Ingrese observaciones..."></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formActions}>
                                <button type="button" className={styles.closeBtn} onClick={() => setShowAgregarModal(false)}>Cancelar</button>
                                <button type="submit" className={styles.Buttons}>Agregar dato</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {/* Modal de Edición */}
            {editRegistro && (
                <div className={styles.modalOverlay}>
                    <div className={`${styles.modal} ${styles.modalForm}`}>
                        <div className={styles.encabezadoModal}>
                            <button className={styles.closeButton} onClick={handleCloseEditModal}>X</button>
                            <h2>Editar Registro</h2>
                        </div>

                        <form onSubmit={handleSaveEdit} className={styles.editForm}>
                            <div className={styles.formBody}>
                                <div className={styles.formGrid}>
                                    <div className={styles.formGroup}>
                                        <label>Fecha</label>
                                        <input
                                            type="date"
                                            value={formatearFechaSimple(editRegistro.fechacompleta)}
                                            onChange={(e) => {
                                                const nuevaFecha = e.target.value;
                                                const fechaActual = new Date(editRegistro.fechacompleta);
                                                const horaActual = editRegistro.hora_edit || `${String(fechaActual.getHours()).padStart(2, '0')}:${String(fechaActual.getMinutes()).padStart(2, '0')}`;
                                                setEditRegistro({ ...editRegistro, fechacompleta: `${nuevaFecha} ${horaActual}` });
                                            }}
                                        />
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Hora</label>
                                        <input
                                            type="time"
                                            value={editRegistro.hora_edit || new Date(editRegistro.fechacompleta).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", hour12: false })}
                                            onChange={(e) => setEditRegistro({ ...editRegistro, hora_edit: e.target.value })}
                                        />
                                    </div>
                                    <div className={styles.formGroup}><label>Placa</label><input type="text" value={editRegistro.placa || ""} onChange={(e) => setEditRegistro({ ...editRegistro, placa: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Peso Neto (t)</label><input type="number" step="0.01" value={editRegistro.pesoneto} onChange={(e) => setEditRegistro({ ...editRegistro, pesoneto: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp1</label><input type="number" value={editRegistro.temp1} onChange={(e) => setEditRegistro({ ...editRegistro, temp1: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp2</label><input type="number" value={editRegistro.temp2} onChange={(e) => setEditRegistro({ ...editRegistro, temp2: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp3</label><input type="number" value={editRegistro.temp3} onChange={(e) => setEditRegistro({ ...editRegistro, temp3: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp4</label><input type="number" value={editRegistro.temp4} onChange={(e) => setEditRegistro({ ...editRegistro, temp4: e.target.value })} /></div>
                                    <div className={styles.formGroup}>
                                        <label>Polución</label>
                                        <select value={editRegistro.polucion} onChange={(e) => setEditRegistro({ ...editRegistro, polucion: e.target.value })}>
                                            <option value="Normal">Normal</option>
                                            <option value="Media">Media</option>
                                            <option value="Alta">Alta</option>
                                        </select>
                                    </div>
                                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                        <label>Observaciones</label>
                                        <textarea rows="2" value={editRegistro.observaciones || ""} onChange={(e) => setEditRegistro({ ...editRegistro, observaciones: e.target.value })} placeholder="Ingrese observaciones..."></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formActions}>
                                <button type="button" className={styles.deleteButton} onClick={handleDelete} style={{ background: "#ef4444", color: "white", borderRadius: "8px", padding: "8px 16px", display: "flex", alignItems: "center", gap: "8px", fontSize: "0.8rem", fontWeight: "700" }}>
                                    <FaTrash /> Eliminar
                                </button>
                                <div style={{ display: "flex", gap: "12px" }}>
                                    <button type="button" className={styles.closeBtn} onClick={handleCloseEditModal}>Cancelar</button>
                                    <button type="submit" className={styles.Buttons}>Actualizar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showAgregarLoteModal && (
                <div className={styles.modalOverlay}>
                    <div className={`${styles.modal} ${styles.modalForm}`}>
                        <div className={styles.encabezadoModal}>
                            <button
                                className={styles.closeButton}
                                onClick={() => setShowAgregarLoteModal(false)}
                            >
                                X
                            </button>
                            <h2>Agregar Nuevo Lote / Origen</h2>
                        </div>

                        <form className={styles.formAgregarDato} onSubmit={handleAgregarNuevoLote}>
                            <div className={styles.formBody}>
                                <div className={styles.formGrid}>
                                    <div className={styles.formGroup}>
                                        <label>¿Es un nuevo origen?</label>
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <input
                                                type="checkbox"
                                                checked={nuevoLoteData.esNuevoOrigen}
                                                onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, esNuevoOrigen: e.target.checked })}
                                            />
                                            <span>Sí, es un material nuevo</span>
                                        </div>
                                    </div>

                                    {!nuevoLoteData.esNuevoOrigen ? (
                                        <div className={styles.formGroup}>
                                            <label>Origen del Material</label>
                                            <select
                                                required
                                                value={nuevoLoteData.idmaterial}
                                                onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, idmaterial: e.target.value })}
                                            >
                                                <option value="">Seleccione origen...</option>
                                                {/* Combinamos materiales de la API con los que ya tienen registros */}
                                                {materiales.map((m) => (
                                                    <option key={m.id} value={m.id}>{m.nombre}</option>
                                                ))}
                                                {/* Por si hay alguno en registros que no esté en la tabla de origenes */}
                                                {origenesProcesados
                                                    .filter(o => !materiales.some(m => m.id == o.lotes[0].registros[0].Idorigen))
                                                    .map((origen) => (
                                                        <option key={origen.nombreOrigen} value={origen.lotes[0].registros[0].Idorigen}>
                                                            {origen.nombreOrigen}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    ) : (
                                        <div className={`${styles.formGroup} ${styles.newOriginField}`}>
                                            <label>Nombre del Nuevo Origen</label>
                                            <div style={{ display: "flex", gap: "8px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="Ej: MINA NORTE"
                                                    style={{ flex: 1 }}
                                                    value={nuevoLoteData.nom_material}
                                                    onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, nom_material: e.target.value.toUpperCase() })}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={handleGuardarNuevoOrigen}
                                                    className={styles.secondaryBtn}
                                                    style={{ padding: "8px 12px", background: "#6c5dd3", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}
                                                >
                                                    <FaPlusCircle /> Guardar
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    <div className={styles.formGroup}>
                                        <label>Placa</label>
                                        <input
                                            type="text"
                                            required
                                            value={nuevoLoteData.placa}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, placa: e.target.value.toUpperCase() })}
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label>Peso Neto (t)</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            required
                                            value={nuevoLoteData.pesoneto}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, pesoneto: e.target.value })}
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label>Muestreado por</label>
                                        <select
                                            required
                                            value={nuevoLoteData.Idusuariom}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, Idusuariom: e.target.value })}
                                        >
                                            <option value="">Seleccione...</option>
                                            {listPreparadores.map((prep) => (
                                                <option key={prep.id} value={prep.id}>{prep.nombre}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label>Registrado por</label>
                                        <select
                                            required
                                            value={nuevoLoteData.Idusuarior}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, Idusuarior: e.target.value })}
                                        >
                                            <option value="">Seleccione...</option>
                                            {listPreparadores.map((prep) => (
                                                <option key={prep.id} value={prep.id}>{prep.nombre}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className={styles.formGroup}><label>Temp 1</label><input type="number" step="0.1" value={nuevoLoteData.temp1} onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, temp1: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp 2</label><input type="number" step="0.1" value={nuevoLoteData.temp2} onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, temp2: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp 3</label><input type="number" step="0.1" value={nuevoLoteData.temp3} onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, temp3: e.target.value })} /></div>
                                    <div className={styles.formGroup}><label>Temp 4</label><input type="number" step="0.1" value={nuevoLoteData.temp4} onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, temp4: e.target.value })} /></div>

                                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                        <label>Plan(es) de Muestreo</label>
                                        <select
                                            required
                                            value={nuevoLoteData.planapptual}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, planapptual: e.target.value })}
                                        >
                                            <option value="">--- Seleccione Plan ---</option>
                                            {(refidData.PlanesMuestreo || []).map(p => (
                                                <option key={p.id} value={p.id}>{p.num_plan}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Polución</label>
                                        <select value={nuevoLoteData.polucion} onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, polucion: e.target.value })}>
                                            <option value="Normal">Normal</option>
                                            <option value="Media">Media</option>
                                            <option value="Alta">Alta</option>
                                        </select>
                                    </div>

                                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                        <label>Observaciones</label>
                                        <textarea
                                            rows="2"
                                            value={nuevoLoteData.observaciones}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, observaciones: e.target.value })}
                                            placeholder="Ingrese observaciones..."
                                        ></textarea>
                                    </div>

                                    <div className={`${styles.formGroup} ${styles.fullWidth}`}>
                                        <label>Foto de Ticket</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => setNuevaFoto(e.target.files[0])}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={styles.formActions}>
                                <button type="button" className={styles.closeBtn} onClick={() => setShowAgregarLoteModal(false)}>Cancelar</button>
                                <button type="submit" className={styles.Buttons}>Iniciar Nuevo Lote</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {
                imagenSeleccionada && (
                    <div className={styles.modalOverlay} onClick={() => {
                        setRotation(0);
                        setImagenSeleccionada(null);
                    }}>
                        <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>

                            <Zoom>
                                <img
                                    src={`https://reporte.incolabcolombia.com.co/${imagenSeleccionada}`}
                                    alt="Imagen ampliada"
                                    style={{
                                        width: "100%",
                                        maxWidth: "600px",
                                        borderRadius: "8px",
                                        cursor: "zoom-in",
                                        transform: `rotate(${rotation}deg)`,
                                        transition: "transform 0.3s ease"
                                    }}
                                />
                            </Zoom>

                            <div style={{ display: "flex", gap: "10px", marginTop: "15px", justifyContent: "center" }}>
                                <button
                                    className={styles.rotateBtn}
                                    onClick={() => setRotation(prev => prev + 90)}
                                >
                                    ↻ Girar
                                </button>

                                <button
                                    className={styles.closeBtn}
                                    onClick={() => {
                                        setRotation(0);
                                        setImagenSeleccionada(null);
                                    }}
                                >
                                    Cerrar
                                </button>
                            </div>

                        </div>
                    </div>
                )
            }

        </div>
    );
};

export default DetallesInbound;
